import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import WriteDelimitedForm from '../forms/write-delimited-form';
import { delimitedWriteValidationSchema } from '../schema/delimited.js';

export default function WriteDelimitedNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Write Delimited Node Details',
        altText: 'Write Delimited Node',
        defaultLabel: 'Write Delimited Node',
      }}
    >
      <CommonNode
        FormComponent={WriteDelimitedForm}
        schemaResolver={delimitedWriteValidationSchema}
      />
    </NodeProvider>
  );
}
